<template>
  <div class="auth-wrapper auth-v2">
    <BRow class="auth-inner register-auth-inner">
      <div class="main_block">
        <div class="header_block_div">
          <div class="reg_logo_section">
            <a class="brand-logo" @click="toAequitex()">
              <img src="../../assets/images/logo/logo-green.png" alt="Logo">
            </a>
          </div>
          <div class="reg-lang-section">
            <div class="register-languages-mobile small_screen_lang d-flex align-items-end justify-content-end">
              <BDropdown
                id="dropdown-grouped"
                text="Dark"
                variant="outline-dark"
                class="dropdown-language no-border-button"
                right
              >
                <template #button-content>
                  <BImg
                    :src="currentLocale.img"
                    height="14px"
                    width="22px"
                    :alt="currentLocale.locale"
                  />
                  <span class="ml-50 text-body">{{ $t(currentLocale.name) }}</span>
                </template>
                <BDropdownItem
                  v-for="localeObj in locales"
                  :key="localeObj.locale"
                  @click="setLocale(localeObj.locale)"
                >
                  <BImg
                    :src="localeObj.img"
                    height="14px"
                    width="22px"
                    :alt="localeObj.locale"
                  />
                  <span class="ml-50">{{ $t(localeObj.name) }}</span>
                </BDropdownItem>
              </BDropdown>
            </div>
          </div>
        </div>

        <div class="reg-content-section">
          <BCol class="row auth-bg register-main-col px-1 p-2 pt-3">
            <BRow
              v-if="!member_company_id"
              class="w-100 mx-0 mb-2"
            >
              <BCol cols="12" class="text-center mb-1 px-2">
                <h1 class="mb-0">
                  {{ $t('register_buttons_paragraph') }}
                </h1>
              </BCol>
              <BCol cols="12" class="mb-2 mb-md-0 p-0">
                <div
                  class="bg-white p-2 rounded-lg shadow h-100 requirement-card"
                  role="button"
                  tabindex="0"
                  @click="showModal = true"
                  @keydown.enter="showModal = true"
                >
                  <p class="mb-2">
                    {{ $t('register_all_button') }}
                  </p>
                  <BButton class="custom-color" @click.stop="showModal = true">
                    {{ $t('more_info') }}
                  </BButton>
                </div>
              </BCol>
            </BRow>

            <div class="form_block rounded-lg">
              <div class="form_block_header">
                <BCardTitle title-tag="h2" class="font-weight-bold mb-0">
                  {{ member_company_id ? $t('member_register_text') : $t('register_text') }}
                </BCardTitle>
              </div>
              <BCol sm="12" class="form_block-body px-xl-2">
                <validation-observer ref="registerValidation">
                  <BForm class="auth-login-form" @submit.prevent="validationForm">
                    <BRow class="m-0">
                      <BFormGroup
                        class="col-12 col-sm-6 p-0"
                        :label="$t('first_name')"
                        label-for="login-first-name"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="First Name"
                          rules="required"
                        >
                          <BFormInput
                            id="login-first-name"
                            v-model.trim="userFirstName"
                            tabindex="1"
                            :state="errors.length > 0 ? false : null"
                            name="login-first-name"
                            placeholder="John"
                            :disabled="disableInputs"
                          />
                          <small class="text-danger">{{ $t(errors[0]) }}</small>
                        </validation-provider>
                      </BFormGroup>
                      <BFormGroup
                        class="col-12 col-sm-6 p-0 pl-md-1"
                        :label="$t('last_name')"
                        label-for="login-last-name"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Last Name"
                          rules="required"
                        >
                          <BFormInput
                            id="login-last-name"
                            v-model.trim="userLastName"
                            :state="errors.length > 0 ? false : null"
                            name="login-last-name"
                            tabindex="2"
                            placeholder="Doe"
                            :disabled="disableInputs"
                          />
                          <small class="text-danger">{{ $t(errors[0]) }}</small>
                        </validation-provider>
                      </BFormGroup>
                    </BRow>

                    <BFormGroup
                      :label="$t('email')"
                      label-for="login-email"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Email"
                        rules="required|email"
                      >
                        <BFormInput
                          id="login-email"
                          v-model.trim="userEmail"
                          :state="errors.length > 0 ? false : null"
                          name="login-email"
                          tabindex="3"
                          placeholder="john@example.com"
                          :disabled="disableInputs || emailFromUrl"
                        />
                        <small class="text-danger">{{ $t(errors[0]) }}</small>
                      </validation-provider>
                    </BFormGroup>

                    <BFormGroup :label="$t('password')" label-for="login-password">
                      <validation-provider
                        #default="{ errors }"
                        name="Password"
                        rules="required"
                      >
                        <BInputGroup
                          class="input-group-merge"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                        >
                          <BFormInput
                            id="login-password"
                            v-model.trim="password"
                            tabindex="4"
                            :state="errors.length > 0 ? false : null"
                            class="form-control-merge"
                            :type="passwordFieldType"
                            name="login-password"
                            placeholder="············"
                            :disabled="disableInputs"
                          />
                          <BInputGroupAppend is-text>
                            <feather-icon
                              class="cursor-pointer"
                              :icon="passwordToggleIcon"
                              @click="togglePasswordVisibility"
                            />
                          </BInputGroupAppend>
                        </BInputGroup>
                        <small class="text-danger">{{ $t(errors[0]) }}</small>
                      </validation-provider>
                    </BFormGroup>

                    <BFormGroup
                      v-if="!member_company_id"
                      :label="$t('how_did_you_become_aware_of_us')"
                      label-for="question"
                    >
                      <BFormSelect
                        id="question"
                        v-model="question"
                        :options="questionOptions"
                        name="question"
                        :disabled="disableInputs"
                      />
                    </BFormGroup>

                    <BFormGroup>
                      <validation-provider
                        #default="{ errors }"
                        name="terms-and-conditions"
                        rules="required"
                      >
                        <BFormCheckbox
                          id="terms-and-conditions"
                          v-model="terms_and_conditions"
                          name="terms-and-conditions"
                          :state="errors.length > 0 ? false : null"
                          :disabled="disableInputs"
                          tabindex="6"
                        >
                          {{ $t('terms_i_accept_the') }}
                          <a target="_blank" @click.prevent="toTerms()">
                            {{ $t('terms_link') }}
                          </a>
                        </BFormCheckbox>
                        <small class="text-danger">{{ $t(errors[0]) }}</small>
                      </validation-provider>
                    </BFormGroup>

                    <BFormGroup>
                      <validation-provider
                        #default="{ errors }"
                        name="data-privacy"
                      >
                        <BFormCheckbox
                          id="data-privacy"
                          v-model="newsletter"
                          name="data-privacy"
                          :state="errors.length > 0 ? false : null"
                          :disabled="disableInputs"
                          tabindex="7"
                        >
                          {{ $t('newsletter_text') }}
                        </BFormCheckbox>
                        <small class="text-danger">{{ $t(errors[0]) }}</small>
                      </validation-provider>
                    </BFormGroup>

                    <BButton
                      type="submit"
                      variant="primary"
                      block
                      :disabled="resLoader"
                      tabindex="8"
                    >
                      <img v-if="resLoader" height="20" src="/new-loader.svg" alt="Loader">
                      {{ $t('register') }}
                    </BButton>
                  </BForm>
                </validation-observer>

                <BCardText class="text-center mt-2">
                  <span>{{ $t('already_registered') }} </span>
                  <BLink tabindex="9" :to="{ name: 'login' }">
                    {{ $t('login_here') }}
                  </BLink>
                </BCardText>
              </BCol>
            </div>
          </BCol>

          <BCol class="right-col">
            <iframe
              id="iframe"
              class="booking-iframe"
              :src="bookingIframeSrc"
              title="Book appointment"
              allowfullscreen=""
            />
          </BCol>
        </div>
      </div>
    </BRow>

    <BModal
      v-model="showModal"
      hide-footer
      size="xl"
      class="custom_modal"
    >
      <BRow class="requirements-modal-row">
        <BCol cols="12" md="6" class="requirements-modal-col">
          <h2>{{ $t('register_seller_button') }}</h2>
          <div
            v-for="(section, index) in sellerModalSections"
            :key="'seller-' + index"
            class="modal_section"
          >
            <ul class="list-style-circle">
              <li>{{ $t(section.title) }}</li>
              <ul class="list-style-square">
                <li v-for="answer in section.answers" :key="answer">
                  {{ $t(answer) }}
                </li>
                <ul v-if="section.nestedAnswers" class="list-style-square">
                  <li v-for="answer in section.nestedAnswers" :key="answer">
                    {{ $t(answer) }}
                  </li>
                </ul>
              </ul>
            </ul>
          </div>
        </BCol>
        <BCol cols="12" md="6" class="requirements-modal-col requirements-modal-col-right">
          <h2>{{ $t('register_buyer_button') }}</h2>
          <div
            v-for="(section, index) in buyerModalSections"
            :key="'buyer-' + index"
            class="modal_section"
          >
            <ul class="list-style-circle">
              <li>{{ $t(section.title) }}</li>
              <ul class="list-style-square">
                <li v-for="answer in section.answers" :key="answer">
                  {{ $t(answer) }}
                </li>
              </ul>
            </ul>
          </div>
        </BCol>
      </BRow>
    </BModal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BFormSelect,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BDropdown,
  BDropdownItem,
  BModal,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const LOCALES = [
  { locale: 'en', img: '/images/flags/en.png', name: 'english' },
  { locale: 'de', img: '/images/flags/german.png', name: 'german' },
]

const BOOKING_IFRAME_SRC = 'https://support-aequitex.zohobookings.eu/portal-embed#/customer/167264000000318034'

const QUESTION_OPTION_KEYS = [
  'google_search',
  'bing_search',
  'linkedin',
  'facebook',
  'instagram',
  'twitter',
  'media',
  'recommendation',
  'direct_contact_e_mail_or_network_event',
  'other',
]

const SELLER_MODAL_SECTIONS = [
  {
    title: 'seller_section1_paragraph',
    answers: [
      'seller_section1_answer1',
      'seller_section1_answer2',
      'seller_section1_answer3',
    ],
  },
  {
    title: 'seller_section2_paragraph',
    answers: [
      'seller_section2_answer1',
      'seller_section2_answer2',
      'seller_section2_answer3',
    ],
    nestedAnswers: [
      'seller_section2_answer4',
      'seller_section2_answer5',
    ],
  },
]

const BUYER_MODAL_SECTIONS = [
  {
    title: 'buyer_section1_paragraph',
    answers: [
      'buyer_section1_answer1',
      'buyer_section1_answer2',
    ],
  },
  {
    title: 'seller_section2_paragraph',
    answers: [
      'buyer_section2_answer1',
      'buyer_section2_answer2',
      'buyer_section2_answer3',
      'buyer_section2_answer4',
      'buyer_section2_answer5',
    ],
  },
]

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BFormSelect,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BDropdown,
    BDropdownItem,
    BModal,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      showModal: false,
      question: '',
      member_company_id: this.$route.query.company_id ?? null,
      resLoader: false,
      terms_and_conditions: false,
      newsletter: false,
      password: '',
      userEmail: '',
      userFirstName: '',
      userLastName: '',
      disableInputs: false,
      emailFromUrl: false,
      required,
      email,
      locales: LOCALES,
      privilegeToken: this.$route.query.privilege_token ?? null,
      bookingIframeSrc: BOOKING_IFRAME_SRC,
      sellerModalSections: SELLER_MODAL_SECTIONS,
      buyerModalSections: BUYER_MODAL_SECTIONS,
    }
  },
  computed: {
    questionOptions() {
      return [
        { value: '', text: this.$t('select_one'), disabled: true },
        ...QUESTION_OPTION_KEYS.map(value => ({
          value,
          text: this.$t(value),
        })),
      ]
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    currentLocale() {
      return this.locales.find(locale => locale.locale === this.$i18n.locale)
        || this.locales[0]
    },
  },
  created() {
    if (this.$route.query.email) {
      this.userEmail = this.$route.query.email
      this.emailFromUrl = true
    }
    if (this.$route.params?.lang && ['en', 'de'].includes(this.$route.params.lang)) {
      this.$i18n.locale = this.$route.params.lang
    }
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale
    },
    toAequitex() {
      window.location.href = 'https://www.aequitex.com/'
    },
    toTerms() {
      const url = this.$i18n.locale === 'en'
        ? 'https://www.aequitex.com/terms-condition'
        : 'https://www.aequitex.com/de/bedingungen-und-konditionen'
      window.open(url, '_blank')
    },
    async validationForm() {
      this.resLoader = true

      const success = await this.$refs.registerValidation.validate()
      if (this.terms_and_conditions !== true) {
        this.terms_and_conditions = false
        await this.$refs.registerValidation.validate()
        this.resLoader = false
        return
      }
      if (!success) {
        this.resLoader = false
        return
      }

      await this.submitRegistration()
    },
    async submitRegistration() {
      this.resLoader = true
      this.disableInputs = true

      const { query } = this.$route
      const member_role = query.role_id ?? null

      try {
        const { data } = await this.$http.post('/register', {
          first_name: this.userFirstName,
          last_name: this.userLastName,
          email: this.userEmail,
          password: this.password,
          password_confirmation: this.password,
          language: this.currentLocale.locale,
          affiliate_code: query.affiliate_code ?? null,
          referrer_role: query.referrer_role ?? null,
          partner_code: query.partner_code ?? null,
          question: this.question,
          company_id: this.member_company_id,
          member_role,
          newsletter: this.newsletter,
          privilege_token: this.privilegeToken,
        })

        if (data.status !== 200) {
          this.showRegistrationError()
          return
        }

        const user = data.value
        this.$store.commit('auth/SET_AUTHENTICATED', true)
        this.$store.commit('auth/SET_USER', user)

        if (this.member_company_id || user.status === 1) {
          this.$store.commit('auth/UPDATE_TOKEN', user.token)
          window.location.href = '/'
        } else {
          this.$router.push('/verify')
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('successfully_registered'),
            icon: 'SuccessIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        console.error('Error:', error)
        this.showRegistrationError()
      }
    },
    showRegistrationError() {
      this.resLoader = false
      this.disableInputs = false
      this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t('failed_to_register_with_provided_credentials'),
          icon: 'ErrorIcon',
          variant: 'error',
        },
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

$register-bg: #f7f6f4;

.custom-color {
  background-color: #488265 !important;
  color: white;
  border-color: #488265 !important;
}

.form_block {
  background-color: white;
  width: 100%;
  overflow: hidden;
  height: fit-content;
}

.form_block .form_block_header {
  width: 100%;
  text-align: center;
  padding: 20px 0 0;
}

.form_block .form_block_header h2,
.form_block .form_block_header span {
  color: #222f28;
}

.form_block input,
.form_block select {
  background-color: $register-bg;
}

.form_block button {
  background-color: #577264 !important;
}

.modal_section {
  min-height: 150px;
  height: auto;
  padding: 20px 0;
  font-weight: 500;
}

.modal_section li {
  margin: 15px 0;
}

.requirements-modal-row {
  margin: 0;
}

.requirements-modal-col-right {
  border-left: 1px solid #d8d6d3;
  padding-left: 1.5rem;
}

@media (max-width: 767.98px) {
  .requirements-modal-col-right {
    border-left: none;
    border-top: 1px solid #d8d6d3;
    padding-left: 0;
    padding-top: 1.5rem;
    margin-top: 1rem;
  }
}

@media screen and (max-width: 992px) {
  .small_screen_lang {
    display: block;
    margin: 25px 0;
    text-align: right !important;
  }
}
</style>

<style scoped lang="scss">
$register-bg: #f7f6f4;

.register-auth-inner {
  margin: 0 auto !important;
}

.main_block {
  width: 100%;
  max-width: 1250px;
  margin: 0 auto;
}

.reg-content-section {
  width: 100%;
  display: flex;
  align-items: flex-start;
}

.reg-content-section > div {
  flex: 1 1 0;
  width: auto;
  min-height: 0;
  display: flex;
  align-items: flex-start;
}

.register-main-col {
  flex-direction: column;
  align-items: stretch !important;
  justify-content: flex-start;
  align-content: flex-start;
  background-color: $register-bg;
  margin: 0 auto;
}

.form_block-body {
  padding: 20px;
}

.requirement-card {
  cursor: pointer;
}

.header_block_div {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  background-color: $register-bg;
}

.brand-logo {
  position: unset !important;
}

.reg_logo_section {
  width: 15%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reg-lang-section {
  width: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.right-col {
  height: calc(100vh - 70px);
  background: transparent;
}

.booking-iframe {
  width: 100%;
  height: 100%;
  border: none;
  padding-top: 80px;
}

@media screen and (max-width: 1250px) {
  .header_block_div > div {
    width: 50%;
  }

  .reg-content-section {
    flex-direction: column;
  }

  .reg-content-section > div {
    width: 100%;
    justify-content: flex-start;
    align-items: stretch;
  }

  .form_block {
    width: 50%;
  }

  .booking-iframe {
    width: 50%;
  }
}

@media screen and (max-width: 800px) {
  .form_block {
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
  }

  .booking-iframe {
    margin-top: 40px;
    width: 100%;
  }
}
</style>
